import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Station from './Station';
import { Api } from '../../../lib/api';
import { HardwareContext } from '../../../context/HardwareContext';

class StationList extends Component {
    static contextType = HardwareContext;

    static propTypes = {
        className: PropTypes.string.isRequired
    };

    state = {
        deviceTypes: []
    };

    componentDidMount() {
        Api.getDeviceTypes().then((deviceTypes) => {
            this.setState({ deviceTypes });
        });
    }

    render() {
        const { stations } = this.context;

        return (
            <div className={this.props.className}>
                {stations.allIds
                    .slice(0)
                    .reverse()
                    .map((id) => (
                        <Station key={id} stationId={id} deviceTypes={this.state.deviceTypes} />
                    ))}
            </div>
        );
    }
}

export default StationList;
